<div class="container-fluid">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-9">
                    <h5 class=""><i class="fa fa-unlink"></i><b> De-Link Carrier Account</b></h5>
                </div>
            </div>
            <hr>
            <br>
            <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
                <legend class="scheduler-border tsk-display">Search</legend>
                <div class="row" style="margin:4px auto!important;padding:0px;font-size:11px!important;">
                    <div class=" col-12 table-responsive-sm" style="width:100%!important;margin:0px;padding:0px;">
                        <table class="" style="width:100%!important;margin:0px;padding:0px;" border="0">
                            <tr class="rmp-all">
                                <td style="width:8%!important;vertical-align:top!important;">
                                    <input type="text" class="form-control pull-left" placeholder="Carrier code..." title="Carrier code to search for." [(ngModel)]="carrierCode" name="carrierCode" value="" />
                                </td>
                                
                                <td style="vertical-align:top!important;width:10%!important;" class="rmp-all">
                                    <!--Button with tooltip and no label -->
                                    <div class="cover-x">
                                        <div class="main-btn rounded-circle rmp-all" (click)="onSearch()" title="Apply filters..." style="margin: 0px auto!important;" rel="tooltip" data-placement="top">
                                            <span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;" aria-hidden="true"></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </fieldset>

            <table class="table table-sm table-striped" style="border-top:none;">
                <thead class="" style="background:white!important;border-top:none;">
                    <tr style="vertical-align:middle;">
                        <th scope="col">Account Number</th>
                        <th scope="col">Account Name</th>
                        <th scope="col">Carrier Type</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tr *ngFor="let acc of carrierAccounts">
                    <td>{{acc.account_number}}</td>
                    <td>{{acc.carrier_name}}</td>
                    <td>{{acc.carrier_type}}</td>
                    <td><button class="btn-add btn btn-primary btn-sm" (click)="enterConfirmation(acc.legacy_carrier_code)" style="font-size: 12px; height: 30px; width: 80px; border-radius: 15px;">De-Link</button></td>
                </tr>
            </table>
        </div>
    </div>
</div>
<button data-toggle="modal" data-target="#OtpModalDeLink" id="secretButtonDeLink" style="display:none"></button>

<div class="modal fade form-group" id="OtpModalDeLink" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <label class="text-center title">Enter verification code</label>
                <button type="button" class="close" data-dismiss="modal" id="closeButton" #closebutton aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body modal-xl">
                <form>
                    <div class="row test">
                        <div class="col-12 sp-fld">
                            <div class="text-center">
                                <small class="extra-clr ft-c" id="OtpMessage"></small><br/>
                            </div>
                            <input #otpInput placeholder="ENTER OTP HERE" style="width: 99%; padding-left: 8px;" />
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-block mt-4 mb-4" (click)="confirm(otpInput)">Confirm</button>
                    </div>
                </form>
            </div>
        </div>

    </div>
</div>